var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "nav-link",
      attrs: {
        href: _vm.urlWishList,
        rel: "nofollow",
        "aria-label": _vm.$translate("Ceres::Template.wishList")
      }
    },
    [
      _c("span", { staticClass: "badge-right d-none" }, [
        _vm._v(_vm._s(_vm.wishListCount))
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "img-fluid d-block mx-auto",
        attrs: {
          src: _vm.$translate("babyVueTheme::Header.HeartIcon"),
          alt: "wishList"
        }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "sub-menu d-block" }, [
        _vm._v(_vm._s(_vm.$translate("Ceres::Template.wishList")))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }